<template>
  <div class="report">
    <div class="search">
      <div class="tabs">
        <div :class="{ item: true, active: activeTab === '0' }" @click="showPage('0')">图表</div>
        <div :class="{ item: true, active: activeTab === '1' }" @click="showPage('1')">数据报表</div>
      </div>
    </div>
    <section v-loading="pageLoading">
      <div class="time">
        <el-row :gutter="20">
          <el-col :span="1.5">
            <div class="label">时间</div>
          </el-col>
          <el-col :span="14">
            <cumstom-date-range :type="0" @change="changeDateRange" @typeChange="search"></cumstom-date-range>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" class="exportData" @click="search">查询</el-button>
            <el-button type="primary" class="exportData" @click="exportTable(vm)" v-loading="exportLoading">导出所有数据</el-button>
            <el-button type="primary" class="exportData" v-if="activeTab === '0'" @click="exportMerchantTable(vm)" v-loading="exportMercantLoading">导出门店汇总数据</el-button>
            <el-button class="setSend" @click="setReaortSend">设置报表发送</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="shopType">
          <el-col :span="1.5">
            <div class="label">门店</div>
          </el-col>
          <el-col :span="3">
            <custom-select v-model="searchFrom.merchantIdList" :list="shopList" @changeShop="changeShop"></custom-select>
            <!-- <custom-select
              v-bind="searchFrom.merchantIdList"
              :list="shopList"
              @changeShop="changeShop"
            ></custom-select> -->
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="1.5">
            <div class="label">收银点</div>
          </el-col>
          <el-col :span="3">
            <custom-select v-model="searchFrom.cashierAreaList" :list="cashierList" type="1"> </custom-select>
          </el-col>
        </el-row>
      </div>
      <div class="survey">
        <div class="surveycon">
          <div class="surverHead itemHead">
            <i></i>
            <span>概况</span>
            <el-tooltip content="每一小时统计一次概况数据" placement="top">
              <i class="tips"></i>
            </el-tooltip>
            <span>{{ tipsDateTimeRange }}</span>
          </div>
          <div class="surverbody">
            <div class="itemCard" v-for="(item, index) in feeAndMoney ? cardArr : cardArr.slice(0, 7)" :key="index" :class="getCardClassName(index)">
              <div class="cardWrap">
                <div class="title">
                  {{ item.title }}
                  <el-tooltip :content="item.tips" placement="top">
                    <i class="tips"></i>
                  </el-tooltip>
                </div>
                <div class="number">{{ item.number }}</div>
                <div class="trend" v-if="needCompare">
                  <i class="rise" v-if="item.icon"></i> <i class="decriase" v-else></i><span>{{ item.trend }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialogBox">
        <el-dialog title="数据报告发送设置" :visible.sync="dialogAutoSet" width="65%" :before-close="closeSetEmail">
          <div class="tips">设置接收报表的邮箱、发送报表的时间，当有交易时系统将每日定时发送昨日的数据报表到相关邮箱</div>
          <div class="content" v-loading="dialogLoading">
            <el-form inline class="inline-form" :model="setForm" v-for="(storeItem, storeIndex) in storeArr" :key="storeIndex" label-width="80px" style="margin-bottom: 30px;align-items: flex-start">
              <el-form-item label="id" style="display:none;">
                <el-input v-model="storeItem.id"></el-input>
              </el-form-item>
              <el-form-item label="门店">
                <custom-select-down v-model="storeItem.merchantIdList"></custom-select-down>
              </el-form-item>
              <el-form-item label="接收时间">
                <el-select v-model="storeItem.receiveTime" placeholder="请选择">
                  <el-option v-for="(item, index) in timeList" :key="index" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="接收邮箱">
                <el-input v-model="storeItem.receiveMailList" placeholder="最多可接收10个邮箱，用逗号隔开即可" style="width:340px;" @change="val => testEmail(val, storeIndex)"></el-input>
              </el-form-item>
              <div class="addAndReduce">
                <span class="add same" @click="addItem(storeIndex)" v-if="storeIndex == storeArr.length - 1">+</span>
                <span class="reduce same" @click="reduceItem(storeIndex)">-</span>
              </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button
                @click="
                  dialogAutoSet = false;
                  canNotSave = false;
                "
                >取 消</el-button
              >
              <el-button type="primary" @click="saveSetEmail" :disabled="canNotSave" :class="{ saveBtnActive: canNotSave }" v-loading="saveEmaliLoading">保 存</el-button>
            </span>
          </div>
        </el-dialog>
      </div>
      <template v-if="activeTab == '0'">
        <chart
          :collectPieAccountData="collectPieAccountData"
          :collectPieNumberData="collectPieNumberData"
          :custom="custom"
          :totalAmount="totalAmount"
          :tradeNum="tradeNum"
          :transactionNum="transactionNum"
          :revenueAmountList="revenueAmountList"
          :merchantChartArr="merchantChartArr"
          :compare="compare"
          :cashierData="cashierData"
        >
        </chart>
      </template>
      <template v-if="activeTab == '1'">
        <transData
          :tipsDateTimeRange="tipsDateTimeRange"
          :customTableData="customTableData"
          :payWayTableDate="payWayTableDate"
          :merchantTableData="merchantTableData"
          :transTableData="transTableData"
          :tableFeeAndMoney="tableFeeAndMoney"
          :cashierTableData="cashierTableData"
        >
        </transData>
      </template>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import chart from "./components/chart.vue";
import { queryShopList } from "@/api/merchant-info";
import { analysis, reportData, operateReceiveMail, listMerchantReceiveMail } from "@/api/report";
import transData from "./components/transData.vue";
import CumstomDateRange from "@/components/CustomDateRange";
import CustomSelect from "@/components/CustomSelect/index.vue";
import CustomSelectDown from "@/components/CustomSelect/down.vue";
import { fetchCashiers } from "@/api/flow";
import { formatDate, debounce, downLoadFileByForm } from "@/utils/index";
import { host, timeList } from "@/global-config";

export default {
  components: {
    chart,
    transData,
    CumstomDateRange,
    CustomSelect,
    CustomSelectDown
    // CashierCompare
  },
  data() {
    return {
      cashierData: {},
      cashierList: [],
      searchFrom: {
        merchantIdList: [],
        startDate: "",
        endDate: "",
        flagChart: true,
        cashierAreaList: []
      },
      activeTab: "0",
      activeTimeType: 0,
      dialogAutoSet: false,
      storeArr: [{ merchantIdList: [], receiveMailList: "", receiveTime: "" }],
      setForm: {},
      shopList: [],
      formEntity: {
        selectedMerchantId: "",
        dateTimeRange: []
      },
      cardArr: [
        {
          title: "收款金额(元)",
          number: 0,
          trend: "",
          icon: true,
          tips: "收款成功的金额总和"
        },
        {
          title: "收款笔数(笔)",
          number: 0,
          trend: "",
          icon: true,
          tips: "收款成功的笔数总和"
        },
        {
          title: "退款金额(元)",
          number: 0,
          trend: "",
          icon: false,
          tips: "成功退款的金额"
        },
        {
          title: "退款笔数(笔)",
          number: 0,
          trend: "",
          icon: true,
          tips: "成功退款的笔数"
        },
        {
          title: "交易笔数(笔)",
          number: 0,
          trend: "",
          icon: true,
          tips: "收款成功笔数+退款成功笔数"
        },
        {
          title: "营业收入(元)",
          number: 0,
          trend: "",
          icon: true,
          tips: "实际的收入金额，既收款成功金额-退款成功金额"
        },
        {
          title: "单笔均价",
          number: 0,
          trend: "",
          icon: true,
          tips: "收款金额/收款笔数"
        },
        {
          title: "手续费",
          number: 0,
          trend: "",
          icon: true,
          tips: "根据不同交易通道进行交易后所产生的手续费"
        },
        {
          title: "结算金额",
          number: 0,
          trend: "",
          icon: true,
          tips: "实际打到商户结算卡中的金额"
        }
      ],
      timeList: timeList,
      collectPieAccountData: [],
      collectPieNumberData: [],
      custom: {},
      needCompare: false,
      totalAmount: {},
      tradeNum: {},
      transactionNum: {},
      revenueAmountList: {},
      merchantChartArr: {},
      customTableData: [],
      payWayTableDate: [],
      cashierTableData: [],
      merchantTableData: [],
      transTableData: [],
      compare: {},
      timeLimit: true,
      allEmailArr: [],
      feeAndMoney: false,
      tableFeeAndMoney: true,
      exportLoading: false,
      exportMercantLoading: false,
      canNotSave: false,
      dialogLoading: true,
      pageLoading: false,
      saveEmaliLoading: false,
      isok: true,
      vm: this,
      shopType: 1
    };
  },
  computed: {
    tipsDateTimeRange() {
      return `${this.searchFrom.startDate} ~ ${this.searchFrom.endDate}`;
    }
  },
  methods: {
    changeShop(data) {
      // this.searchFrom.merchantIdList = data
      if (data.length === 0) {
        this.cashierList = [];
        return;
      }
      if (data[0] === "@") {
        this.queryCashierList(this.shopList.slice(1).map(v => v.merchantId));
      } else {
        this.queryCashierList(data);
      }
      // this.searchFrom.cashierAreaList.map(v=>{
      //   if(!this.cashierList.includes(v)){
      //     this.searchFrom.cashierAreaList
      //   }
      // })
    },
    closeSetEmail() {
      this.dialogAutoSet = false;
      this.canNotSave = false;
      this.saveEmaliLoading = false;
      this.dialogLoading = false;
    },
    // 导出
    exportTable: debounce(
      vm => {
        if (vm.searchFrom.merchantIdList.length === 0) {
          vm.$message({
            showClose: true,
            message: "请至少选择一个门店",
            type: "error"
          });
        } else {
          vm.exportList();
        }
      },
      200,
      true
    ),
    exportMerchantTable: debounce(
      vm => {
        vm.exporMerchanttList();
      },
      200,
      true
    ),
    exporMerchanttList() {
      const loginInfo = JSON.parse(window.localStorage.getItem("LOGIN_INFO"));
      const { userName, sessionId } = loginInfo;
      const url = `${host}/report/exportSummaryData?userName=${userName}&sessionId=${sessionId}`;
      const param = Object.assign({}, this.searchFrom);
      if (this.searchFrom.merchantIdList[0] === "@") {
        param.merchantIdList = [];
        this.shopList.forEach(v => {
          if (v.merchantId !== "@") {
            param.merchantIdList.push(v.merchantId);
          }
        });
      }
      if (param.cashierAreaList[0] === "@") {
        param.cashierAreaList = [];
        this.cashierList.forEach(v => {
          if (v.cashierAreaNo !== "@") {
            param.cashierAreaList.push(v.cashierAreaNo);
          }
        });
      }
      downLoadFileByForm(url, param);
      this.exportMercantLoading = false;
    },
    exportList() {
      const loginInfo = JSON.parse(window.localStorage.getItem("LOGIN_INFO"));
      const { userName, sessionId } = loginInfo;
      const url = `${host}/report/exportData?userName=${userName}&sessionId=${sessionId}`;
      const param = Object.assign({}, this.searchFrom);
      if (this.searchFrom.merchantIdList[0] === "@") {
        param.merchantIdList = [];
        this.shopList.forEach(v => {
          if (v.merchantId !== "@") {
            param.merchantIdList.push(v.merchantId);
          }
        });
      }
      if (param.cashierAreaList[0] === "@") {
        param.cashierAreaList = [];
        this.cashierList.forEach(v => {
          if (v.cashierAreaNo !== "@") {
            param.cashierAreaList.push(v.cashierAreaNo);
          }
        });
      }
      downLoadFileByForm(url, param);
      this.exportLoading = false;
    },
    // 动态绑定class
    getCardClassName(index) {
      return `itemCard${index + 1}`;
    },
    addItem(index) {
      if (this.storeArr[index].merchantIdList.length === 0 || this.storeArr[index].receiveTime === "") {
        this.$message({
          showClose: true,
          message: "请选择完整值在添加",
          type: "error"
        });
      } else {
        // this.storeArr.push({});
        this.storeArr.push({ merchantIdList: [], receiveMailList: "", receiveTime: "" });
      }
    },
    reduceItem(index) {
      if (this.storeArr.length > 1) {
        this.storeArr.splice(index, 1);
      } else {
        this.storeArr = [{ merchantIdList: [], receiveMailList: "", receiveTime: "" }];
      }
    },
    // 获取门店列表
    queryShopList() {
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo: 1,
        pageSize: 1000
      };
      return queryShopList(params).then(res => {
        if (res.data.error_code === 0) {
          res.data.data.list.unshift({ merchantId: "@", merchantName: "全部门店", checked: true });
          this.shopList = res.data.data.list;
          this.searchFrom.merchantIdList = [this.shopList[0].merchantId];
          this.getPieChartData();
        }
      });
    },
    setReaortSend() {
      this.dialogAutoSet = true;
      this.getEmailList();
    },
    // 验证重复元素，有重复返回true；否则返回false
    isRepeat(arr) {
      const hash = {};
      for (let i = 0; i < arr.length; i++) {
        if (hash[arr[i]] && arr[i] !== "") {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    // 检测邮箱
    testEmail(val, index) {
      val = val.replace(/，/gi, ",");
      const emailArr = val.split(",");
      if (emailArr.length > 10) {
        this.$message({
          showClose: true,
          message: "每个数据最多支持发送10个邮箱",
          type: "error"
        });
        if (this.storeArr[index].receiveMailList !== "") {
          const currentArr = this.storeArr[index].receiveMailList.split(",").splice(0, 10);
          this.storeArr[index].receiveMailList = currentArr.join();
          this.canNotSave = true;
          return;
        }
      }
      const reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      emailArr.forEach(e => {
        if (e !== "") {
          this.isok = reg.test(e);
        }
      });
      if (!this.isok) {
        this.$message({
          showClose: true,
          message: "邮箱格式不正确，请重新输入",
          type: "error"
        });
        this.canNotSave = true;
      } else {
        this.allEmail = [];
        for (let i = 0; i < this.storeArr.length; i++) {
          if (this.storeArr[i].receiveMailList !== undefined) {
            this.storeArr[i].receiveMailList = this.storeArr[i].receiveMailList.replace(/，/gi, ",");
            for (let j = 0; j < this.storeArr[i].receiveMailList.split(",").length; j++) {
              if (this.storeArr[i].receiveMailList.split(",")[j] !== "") {
                this.allEmail.push(this.storeArr[i].receiveMailList.split(",")[j]);
              }
            }
          }
        }
        if (this.isRepeat(this.allEmail)) {
          this.$message({
            showClose: true,
            message: "同一个邮箱只能添加一次",
            type: "error"
          });
          this.canNotSave = true;
        } else {
          this.canNotSave = false;
        }
      }
    },
    // 发送邮件
    saveSetEmail() {
      this.noAllData = false;
      for (let i = 0; i < this.storeArr.length; i++) {
        if (
          this.storeArr[i].merchantIdList.length === 0 ||
          this.storeArr[i].receiveTime === undefined ||
          this.storeArr[i].receiveTime === "" ||
          this.storeArr[i].receiveMailList === undefined ||
          this.storeArr[i].receiveMailList === ""
        ) {
          this.noAllData = true;
          break;
        }
      }
      if (this.storeArr.length === 1) {
        // 长度为1时需要判断用户是否是想要置空发送邮件的数据，如果三个值都没有填写，那就是置空
        if (this.storeArr[0].merchantIdList.length === 0 && this.storeArr[0].receiveMailList === "" && this.storeArr[0].receiveTime === "") {
          this.sendEmailAip();
        } else if (this.storeArr[0].merchantIdList.length === 0 || this.storeArr[0].receiveMailList === "" || this.storeArr[0].receiveTime === "") {
          this.$message({
            showClose: true,
            message: "请添加完整值后在保存",
            type: "error"
          });
        } else {
          this.sendEmailAip();
        }
      } else if (this.storeArr.length > 1) {
        if (this.noAllData) {
          this.$message({
            showClose: true,
            message: "请添加完整值后在保存",
            type: "error"
          });
        } else {
          this.sendEmailAip();
        }
      }
    },
    sendEmailAip() {
      const storeModddleArr = [];
      this.storeArr.map(e => {
        //如果邮箱以逗号结尾，去掉逗号
        e.receiveMailList = e.receiveMailList.slice(e.receiveMailList.length - 1) === "," ? e.receiveMailList.slice(0, -1) : e.receiveMailList;
        const emailArr = e.receiveMailList.split(",");
        const itemArr = {
          id: e.id,
          receiveMailList: emailArr,
          receiveTime: e.receiveTime,
          merchantIdList: e.merchantIdList
        };
        storeModddleArr.push(itemArr);
        return false;
      });
      const params = {
        mailList: storeModddleArr
      };
      this.saveEmaliLoading = true;
      operateReceiveMail(params).then(res => {
        this.saveEmaliLoading = false;
        if (res.data.error_code === 0) {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
          this.dialogAutoSet = false;
        }
      });
    },
    // 邮箱列表查询
    getEmailList() {
      this.dialogLoading = true;
      listMerchantReceiveMail().then(res => {
        this.dialogLoading = false;
        const middleArr = [];
        if (res.data.error_code === 0) {
          const resData = res.data.data;
          if (resData.length > 0) {
            resData.map(e => {
              const emialStr = e.receiveMailList.join();
              const merchantCodeArr = e.merchantList.map(ele => ele.merchantId);
              const middleObj = {
                id: e.id,
                merchantIdList: merchantCodeArr,
                receiveTime: e.receiveTime,
                receiveMailList: emialStr
              };
              middleArr.push(middleObj);
              return false;
            });
            this.storeArr = middleArr;
          } else {
            this.storeArr = [{ merchantIdList: [], receiveMailList: "", receiveTime: "" }];
          }
        }
      });
    },
    // 时间处理
    changeDateRange(dateRange) {
      this.searchFrom.startDate = formatDate(dateRange[0]);
      this.searchFrom.endDate = formatDate(dateRange[1]);

      const date = new Date().getTime();
      // 日期包含今天不显示概况里面的手续费和结算金额,如果开始日期等于结束日期就不显示表格里面的手续费和结算金额
      this.feeAndMoney = formatDate(date) === formatDate(dateRange[1]) ? false : true;
      this.tableFeeAndMoney = formatDate(dateRange[0]) === formatDate(dateRange[1]) ? false : true;
    },
    // 饼状图和顾客人数数据和营业收入
    getPieChartData() {
      this.pageLoading = true;
      let param = Object.assign({}, this.searchFrom);
      // 如果是全部门店，需要遍历获取所有的门店id
      // console.log(param)
      if (this.searchFrom.merchantIdList[0] === "@") {
        param.merchantIdList = [];
        this.shopList.forEach(v => {
          if (v.merchantId !== "@") {
            param.merchantIdList.push(v.merchantId);
          }
        });
      }
      if (param.cashierAreaList[0] === "@") {
        param.cashierAreaList = [];
        this.cashierList.forEach(v => {
          if (v.cashierAreaNo !== "@") {
            param.cashierAreaList.push(v.cashierAreaNo);
          }
        });
      }
      if (param.merchantIdList.length === 0) {
        this.$message({
          message: "请选择门店",
          type: "error"
        });
        this.pageLoading = false;
        return;
      }
      Promise.all([analysis(param), reportData(param)]).then(result => {
        if (result[0].data.error_code === 0) {
          const resData = result[0].data.data;
          // 顾客人数
          this.custom = {
            data: resData.regularCustomerNumList,
            newData: resData.newCustomerNumList,
            time: resData.dateList,
            needCompare: resData.needCompare,
            differenceCustomerNum: resData.differenceCustomerNum,
            totalCustomerNum: resData.totalCustomerNum,
            timeNow: `${this.searchFrom.startDate.substring(0, 10)} ~ ${this.searchFrom.endDate.substring(0, 10)}`
          };
          // 数据为0的不显示
          this.collectPieAccountData = [];
          if (resData.revAmtAlipay) {
            this.collectPieAccountData.push({
              value: resData.revAmtAlipay / 100,
              name: "支付宝"
            });
          }
          if (resData.revAmtWechat) {
            this.collectPieAccountData.push({
              value: resData.revAmtWechat / 100,
              name: "微信"
            });
          }
          if (resData.revAmtCloud) {
            this.collectPieAccountData.push({
              value: resData.revAmtCloud / 100,
              name: "云闪付"
            });
          }
          if (resData.revAmtUnion) {
            this.collectPieAccountData.push({
              value: resData.revAmtUnion / 100,
              name: "银联"
            });
          }
          if (resData.fRevAmtDc) {
            this.collectPieAccountData.push({
              value: resData.fRevAmtDc / 100,
              name: "数字人民币"
            });
          }
          this.collectPieNumberData = [];
          if (resData.revNumAlipay) {
            this.collectPieNumberData.push({
              value: resData.revNumAlipay,
              name: "支付宝"
            });
          }
          if (resData.revNumWechat) {
            this.collectPieNumberData.push({
              value: resData.revNumWechat,
              name: "微信"
            });
          }
          if (resData.revNumCloud) {
            this.collectPieNumberData.push({
              value: resData.revNumCloud,
              name: "云闪付"
            });
          }
          if (resData.revNumUnion) {
            this.collectPieNumberData.push({
              value: resData.revNumUnion,
              name: "银联"
            });
          }
          if (resData.fRevNumDc) {
            this.collectPieNumberData.push({
              value: resData.fRevNumDc,
              name: "数字人民币"
            });
          }
        }
        if (result[1].data.error_code === 0) {
          const resData = result[1].data.data.chart;
          // 概况
          this.needCompare = resData.needCompare;
          this.surverGetData(resData);

          // 收款金额,收款笔数，交易笔数，营业收入
          this.totalAmount = {
            num: resData.totalAmount,
            time: resData.date
          };
          this.tradeNum = {
            num: resData.tradeNum,
            time: resData.date
          };
          this.transactionNum = {
            num: resData.transactionNum,
            time: resData.date
          };
          this.revenueAmountList = {
            num: resData.revenueAmountList,
            time: resData.date
          };
          // 返回的收银点数据
          this.cashierData = {
            num: resData.cashierAreaData,
            rankType: 1,
            showCashierChart: this.showCashierChart
          };
          // 收款金额收款笔数交易笔数对比
          this.compare = {
            needCompare: resData.needCompare,
            totalAmount: resData.revenueGeneralInfo.totalAmount / 100,
            tradeNum: resData.revenueGeneralInfo.tradeNum,
            transactionNum: resData.revenueGeneralInfo.transactionNum,
            differenceAmount: resData.differenceAmount / 100,
            differenceTradeNum: resData.differenceTradeNum,
            differenceTransactionNum: resData.differenceTransactionNum,
            revenueAmount: resData.revenueGeneralInfo.revenueAmount / 100,
            differenceRevenueAmount: resData.differenceRevenueAmount
          };
          // 门店对比柱状图
          this.merchantChartArr = {
            name: resData.merchantNameList,
            num: resData.merchantTradeNum,
            amount: resData.merchantTotalAmount,
            merchantIdList: this.searchFrom.merchantIdList
          };
        }
        this.pageLoading = false;
      });
    },

    // 表格数据
    getTableData() {
      this.pageLoading = true;
      const param = Object.assign({}, this.searchFrom);
      param.flagChart = false;
      // 如果是全部门店，需要遍历获取所有的门店id
      if (this.searchFrom.merchantIdList[0] === "@") {
        param.merchantIdList = [];
        this.shopList.forEach(v => {
          if (v.merchantId !== "@") {
            param.merchantIdList.push(v.merchantId);
          }
        });
      }
      if (param.cashierAreaList[0] === "@") {
        param.cashierAreaList = [];
        this.cashierList.forEach(v => {
          if (v.cashierAreaNo !== "@") {
            param.cashierAreaList.push(v.cashierAreaNo);
          }
        });
      }
      if (param.merchantIdList.length === 0) {
        this.$message({
          message: "请选择门店",
          type: "error"
        });
        this.pageLoading = false;
        return;
      }
      Promise.all([analysis(param), reportData(param)]).then(result => {
        if (result[0].data.error_code === 0) {
          const resData = result[0].data.data;
          this.customTableData = resData.mapList.reverse();
          // 如果都为0， table需要显示暂无数据
          if (!resData.revAmtAlipay && !resData.revAmtWechat && !resData.revAmtCloud && !resData.revAmtUnion) {
            this.payWayTableDate = [];
          } else {
            this.payWayTableDate = [
              {
                name: "支付宝",
                money: resData.revAmtAlipay || 0,
                num: resData.revNumAlipay || 0
              },
              {
                name: "微信",
                money: resData.revAmtWechat || 0,
                num: resData.revNumWechat || 0
              },
              {
                name: "云闪付",
                money: resData.revAmtCloud || 0,
                num: resData.revNumCloud || 0
              },
              {
                name: "银联",
                money: resData.revAmtUnion || 0,
                num: resData.revNumUnion || 0
              }
            ];
          }
        }

        if (result[1].data.error_code === 0) {
          const resData = result[1].data.data.list;
          this.merchantTableData = resData.merchantDataList;
          this.transTableData = resData.transList.reverse();
          // 概况
          this.needCompare = resData.needCompare;
          this.surverGetData(resData);

          // 这里为表格数据赋值
          this.cashierTableData = resData.cashierAreaDataList || [];
        }

        this.pageLoading = false;
      });
    },
    // 概况赋值
    surverGetData(resData) {
      this.cardArr[0].number = resData.revenueGeneralInfo.totalAmount / 100;
      this.cardArr[1].number = resData.revenueGeneralInfo.tradeNum;
      this.cardArr[2].number = resData.revenueGeneralInfo.refundAmount / 100;
      this.cardArr[3].number = resData.revenueGeneralInfo.refundNum;
      this.cardArr[4].number = resData.revenueGeneralInfo.transactionNum;
      this.cardArr[5].number = resData.revenueGeneralInfo.revenueAmount / 100;
      this.cardArr[6].number = resData.revenueGeneralInfo.averageTransAmount;
      this.cardArr[7].number = resData.revenueGeneralInfo.fee / 100;
      this.cardArr[8].number = resData.revenueGeneralInfo.settleAmount / 100;
      this.cardArr[0].trend =
        resData.differenceAmount > 0 || resData.differenceAmount === 0 ? `比前一天增加${resData.differenceAmount / 100}元` : `比前一天减少${Math.abs(resData.differenceAmount) / 100}元`;
      this.cardArr[0].icon = resData.differenceAmount > 0 || resData.differenceAmount === 0;
      this.cardArr[1].trend =
        resData.differenceTradeNum > 0 || resData.differenceAmount === 0 ? `比前一天增加${resData.differenceTradeNum}笔` : `比前一天减少${Math.abs(resData.differenceTradeNum)}笔`;
      this.cardArr[1].icon = resData.differenceTradeNum > 0 || resData.differenceAmount === 0;
      this.cardArr[4].trend =
        resData.differenceTransactionNum > 0 || resData.differenceAmount === 0 ? `比前一天增加${resData.differenceTransactionNum}笔` : `比前一天减少${Math.abs(resData.differenceTransactionNum)}笔`;
      this.cardArr[4].icon = resData.differenceTransactionNum > 0 || resData.differenceAmount === 0;
    },
    showPage(index) {
      this.activeTab = index;
      if (index === "0") {
        this.getPieChartData();
      } else {
        this.getTableData();
      }
    },
    // 查询按钮
    search() {
      if (this.searchFrom.merchantIdList.length === 0) {
        this.$message({
          showClose: true,
          message: "请至少选择一个门店",
          type: "error"
        });
      } else if (this.activeTab === "0") {
        this.getPieChartData();
      } else {
        this.getTableData();
      }
    },
    queryCashierList(data) {
      fetchCashiers(data).then(res => {
        if (res.data.error_code === 0) {
          if (res.data.data.list.length === 0) {
            this.showCashierChart = false;
          } else {
            this.showCashierChart = true;
            res.data.data.list.unshift({ cashierAreaNo: "@", cashierAreaName: "全部收银点" });
          }
          this.cashierList = res.data.data.list;
          //  切换商户后未变收银点保留
          this.searchFrom.cashierAreaList = this.searchFrom.cashierAreaList.filter(v => {
            return this.cashierList.map(val => val.cashierAreaNo).includes(v);
          });
        }
      });
    }
  },
  watch: {
    "searchFrom.merchantIdList": {
      deep: true,
      handler(newVal) {
        if (newVal.length === 0) {
          this.searchFrom.cashierAreaList = [];
        }
      },
    },
  },
  async mounted() {
    await this.queryShopList();
    if (JSON.parse(window.localStorage.getItem("LOGIN_INFO"))) {
      this.shopType = JSON.parse(window.localStorage.getItem("LOGIN_INFO")).shopType;
    }
  }
};
</script>

<style lang="scss">
.report {
  section {
    background: #eee;
  }
  .search {
    .tabs {
      padding-left: 50px;
      background-color: #fff;
      display: flex;
      border-bottom: 1px solid #f2f3f3;
      height: 80px;
      align-items: center;
      .item {
        height: 80px;
        line-height: 80px;
        cursor: pointer;
        color: #333333;
        font-size: 18px;
        margin-right: 60px;
        &.active {
          border-bottom: 2px solid #ff9600;
        }
      }
    }
    .exportData {
      border: none;
      width: 101px;
      height: 32px !important;
      background: #ff9c00;
      font-size: 14px;
    }
    .setSend {
      width: 101px;
      height: 32px;
      border: 1px solid rgba(255, 156, 0, 1);
      border-radius: 4px;
      background: #fff;
      color: #ff9c00;
    }
  }
  .time {
    .el-button {
      line-height: 0.5;
    }
    .label {
      font-size: 14px;
      width: 50px;
    }
    background-color: #fff;
    margin-bottom: 20px;
    padding: 40px 0 20px 50px;
    > .el-row {
      // margin:0!important;
      margin-bottom: 20px;
      // &:last-child {
      //   padding-top: 20px;
      // }
      .el-col {
        .label {
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
  .survey {
    background: #f7f7f7;
    overflow: hidden;
    .surveycon {
      padding: 24px 50px 40px;
      background: #fff;
    }
    .surverHead {
      display: flex;
      align-items: center;
      i {
        background: url("../../assets/images/report/Survey.png") no-repeat;
        background-size: 100%;
        width: 24px;
        height: 24px;
        display: block;
      }
      span {
        color: #333333;
        font-size: 18px;
        margin-left: 13px;
        display: block;
      }
      .tips {
        width: 16px;
        height: 16px;
        display: inline-block;
        background: url("../../assets/images/report/questionh.png") no-repeat;
        background-size: 100%;
        margin-left: 6px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .surverbody {
      display: flex;
      align-content: space-between;
      color: #fff;
      margin-top: 24px;
      .itemCard {
        margin-right: 1%;
        padding: 25px 0;
        height: 142px;
        border-radius: 8px;
        width: 16%;
        display: flex;
        align-items: center;
        justify-items: center;
        .cardWrap {
          text-align: center;
          margin: auto;
        }
        .title {
          font-size: 16px;
          font-weight: 400;
          .tips {
            width: 16px;
            height: 16px;
            display: inline-block;
            background: url("../../assets/images/report/questionb.png") no-repeat;
            background-size: 100%;
            margin-left: 6px;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        .number {
          font-size: 32px;
          margin-top: 10px;
          font-weight: bold;
        }
        .trend {
          margin-top: 18px;
          i {
            width: 10px;
            height: 13px;
            display: inline-block;
            vertical-align: middle;
          }
          .rise {
            background: url("../../assets/images/report/toprow.png") no-repeat;
            background-size: 100%;
          }
          .decriase {
            background: url("../../assets/images/report/bottomrow.png") no-repeat;
            background-size: 100%;
          }
          span {
            margin-left: 10px;
            font-size: 14px;
          }
        }
      }
      .itemCard1 {
        background-image: linear-gradient(to right, #ffc400, #ffae00);
      }
      .itemCard2 {
        background-image: linear-gradient(to right, #00b5ff, #009eff);
      }
      .itemCard3 {
        background-image: linear-gradient(to right, #48e3bb, #43deaa);
        .trend {
          display: none;
        }
      }
      .itemCard4 {
        background-image: linear-gradient(to right, #ff8383, #fe6a6a);
        .trend {
          display: none;
        }
      }
      .itemCard5 {
        background-image: linear-gradient(to right, #bdbdbd, #b3b3b3);
      }
      .itemCard6 {
        background-image: linear-gradient(to right, #8de047, #7bd539);
        .trend {
          display: none;
        }
      }
      .itemCard7 {
        background-image: linear-gradient(to right, #00b5ff, #009eff);
        .trend {
          display: none;
        }
      }
      .itemCard8 {
        background-image: linear-gradient(to right, #48e3bb, #43deaa);
        .trend {
          display: none;
        }
      }
      .itemCard9 {
        background-image: linear-gradient(to right, #ff8383, #fe6a6a);
        .trend {
          display: none;
        }
      }
      .itemCard:last-child {
        margin-right: 0;
      }
    }
  }
  //弹窗
  .dialogBox {
    .el-dialog {
      border-radius: 6px;
      min-width: 1200px;
    }
    .el-dialog__header {
      padding: 40px 40px 0;
      .el-dialog__title {
        color: #000;
        font-size: 22px;
      }
    }
    .el-dialog__body {
      padding: 0 40px;
      .tips {
        color: #666;
        font-size: 14px;
        margin-top: 14px;
      }
      .content {
        margin-top: 54px;
        .el-form {
          display: flex;
          align-items: center;
          margin-bottom: 22px;
          .label {
            font-size: 14px;
          }
        }
        .el-form-item {
          margin-bottom: 0;
          margin-right: 30px;
          .el-form-item__label {
            color: #333;
          }
        }
        .same {
          width: 38px;
          height: 38px;
          border-radius: 2px;
          background: #f2f2f2;
          color: #cdcdcd;
          font-size: 32px;
          display: inline-block;
          line-height: 38px;
          text-align: center;
          cursor: pointer;
        }
        .add {
          margin-right: 10px;
        }
      }
    }
    .dialog-footer {
      padding: 40px 0 40px 0;
      width: 100%;
      display: block;
      text-align: right;
      .el-button {
        width: 101px;
        height: 32px;
        border-radius: 4px;
        font-size: 16px;
        line-height: 0;
        background: #ececec;
        color: #666;
        border: none;
      }
      .el-button--primary {
        background: #ff9c00;
        color: #fff;
      }
      .saveBtnActive {
        background: #ececec;
        color: #666;
      }
    }
    .addAndReduce {
      min-width: 86px;
    }
  }
}
</style>
